import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import WhyJoinUs from "../components/WhyJoinUs";
import CommissionCalculator from "../components/CommissionCalculator";
import FeeStructure from "../components/FeeStructure";
import WeeklyTraining from "../components/WeeklyTraining";
import SoftwareStack from "../components/SoftwareStack";
import CTABand from "../components/CTABand";
import Footer from "../components/Footer";
import GetInfoDialog from "../components/GetInfoDialog";

export default function HomePage() {
  const [infoOpen, setInfoOpen] = useState(false);
  const openInfo = () => setInfoOpen(true);

  return (
    <div data-testid="home-page" className="min-h-screen bg-[#ffffff] text-[#0a0a0a]">
      <Navbar />
      <Hero onGetInfo={openInfo} />
      <WhyJoinUs />
      <CommissionCalculator />
      <FeeStructure />
      <WeeklyTraining />
      <SoftwareStack />
      <CTABand onGetInfo={openInfo} />
      <Footer />
      <GetInfoDialog open={infoOpen} onOpenChange={setInfoOpen} />
    </div>
  );
}
